// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AcademiaIcon-cls1___8284bde52f87efc2857{/*!*/}.AcademiaIcon-cls2___a04ac7e6e682a33f978{margin-right:24px;cursor:pointer;height:24px;width:24px}@media(max-width: 625px){.AcademiaIcon-cls2___a04ac7e6e682a33f978{margin-right:16px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AcademiaIcon-cls1___8284bde52f87efc2857",
	"cls2": "AcademiaIcon-cls2___a04ac7e6e682a33f978 AcademiaIcon-cls1___8284bde52f87efc2857"
};
export default ___CSS_LOADER_EXPORT___;
